import React from "react";
import { Link } from "react-router-dom";
import { classNames } from "../../helpers/classNames";

const Button = ({
  buttonEffect = "",
  buttonClasses,
  buttonType = "button",
  buttonIcon,
  buttonIconPosition = "left",
  buttonLabel,
  buttonLabelClasses,
  buttonFunction = () => {},
  buttonHasLink,
  buttonLink,
  isDisable = false,
  loading = false,
  target,
  ...props
}) => {
  return (
    <>
      {buttonHasLink ? (
        <Link
          to={buttonLink}
          {...(target && { target })}
          className={classNames(
            "font-CanelaDeck relative overflow-hidden flex justify-center items-center gap-2 bg-primary text-white rounded-md text-base h-10 py-0 px-3 transition-all duration-200 hover:bg-secondary",
            buttonClasses,
            isDisable ? "pointer-events-none opacity-75" : ""
          )}
          onClick={buttonFunction}
        >
          {buttonIconPosition === "left" && (loading || buttonIcon) && (
            <i
              className={classNames(
                "fa-fw",
                loading
                  ? "fa-duotone fa-solid fa-spinner-third animate-spin"
                  : buttonIcon
              )}
            ></i>
          )}
          {buttonLabel && (
            <span className={classNames("text-base", buttonLabelClasses)}>
              {buttonLabel}
            </span>
          )}
          {buttonIconPosition === "right" && (loading || buttonIcon) && (
            <i
              className={classNames(
                "fa-fw",
                loading
                  ? "fa-duotone fa-solid fa-spinner-third animate-spin"
                  : buttonIcon
              )}
            ></i>
          )}
        </Link>
      ) : (
        <button
          type={buttonType}
          className={classNames(
            "font-CanelaDeck relative overflow-hidden flex justify-center items-center gap-2 bg-black text-white rounded-md text-base h-10 py-0 px-3 transition-all duration-200 hover:bg-primary",
            buttonClasses,
            isDisable ? "pointer-events-none opacity-75" : ""
          )}
          onClick={buttonFunction}
          disabled={isDisable}
        >
          {buttonIconPosition === "left" && (loading || buttonIcon) && (
            <i
              className={classNames(
                "fa-fw",
                loading
                  ? "fa-duotone fa-solid fa-spinner-third animate-spin"
                  : buttonIcon
              )}
            ></i>
          )}
          {buttonLabel && (
            <span className={classNames("text-base", buttonLabelClasses)}>
              {buttonLabel}
            </span>
          )}
          {buttonIconPosition === "right" && (loading || buttonIcon) && (
            <i
              className={classNames(
                "fa-fw",
                loading
                  ? "fa-duotone fa-solid fa-spinner-third animate-spin"
                  : buttonIcon
              )}
            ></i>
          )}
        </button>
      )}
    </>
  );
};

export default Button;
